import { msg } from "@lingui/macro";
import type { MessageDescriptor } from "@lingui/core";

import type {
  ContractType,
  Grade,
  NodeType,
  RecommendedActionCode,
  RiskLevel,
  Severity,
  SkillCategory,
  ToolCategory,
} from "../types";

const severityMessages: Record<Severity, MessageDescriptor> = {
  low: msg`низкая значимость`,
  medium: msg`средняя значимость`,
  high: msg`высокая значимость`,
  critical: msg`критическая значимость`,
};

const riskLevelMessages: Record<RiskLevel, MessageDescriptor> = {
  low: msg`низкий риск`,
  medium: msg`средний риск`,
  high: msg`высокий риск`,
};

const nodeTypeMessages: Record<NodeType, MessageDescriptor> = {
  public_site: msg`публичный сайт`,
  admin_panel: msg`админ-панель`,
  database: msg`база данных`,
  office_laptops: msg`офисные ноутбуки`,
  vendor_access: msg`доступ подрядчика`,
  cloud_storage: msg`облачное хранилище`,
};

const recommendedActionMessages: Record<RecommendedActionCode, MessageDescriptor> = {
  enable_mfa: msg`включить MFA`,
  review_admin_roles: msg`пересмотреть роли администраторов`,
  add_monitoring: msg`добавить мониторинг и уведомления`,
  rotate_credentials: msg`сменить учётные данные`,
  restrict_vendor_access: msg`ограничить доступ подрядчика`,
  patch_public_site: msg`обновить и закрыть уязвимости сайта`,
  encrypt_backups: msg`шифровать резервные копии`,
  segment_network: msg`сегментировать сеть`,
  disable_unused_accounts: msg`отключить неиспользуемые учётные записи`,
  enforce_password_policy: msg`ввести политику паролей`,
  enable_audit_logging: msg`включить аудит-логирование`,
  limit_data_export: msg`ограничить экспорт данных`,
};

const gradeMessages: Record<Grade, MessageDescriptor> = {
  S: msg`S`,
  A: msg`A`,
  B: msg`B`,
  C: msg`C`,
  Failed: msg`Провал`,
};

const contractTypeMessages: Record<ContractType, MessageDescriptor> = {
  log_analysis: msg`Анализ логов`,
  network_map: msg`Карта сети`,
  phishing: msg`Разбор почты`,
  report_builder: msg`Сборка отчёта`,
};

export function severityText(severity: Severity): MessageDescriptor {
  return severityMessages[severity];
}

export function riskLevelText(riskLevel: RiskLevel): MessageDescriptor {
  return riskLevelMessages[riskLevel];
}

export function nodeTypeText(nodeType: NodeType): MessageDescriptor {
  return nodeTypeMessages[nodeType];
}

export function recommendedActionText(code: RecommendedActionCode): MessageDescriptor {
  return recommendedActionMessages[code];
}

export function gradeText(grade: Grade): MessageDescriptor {
  return gradeMessages[grade];
}

export function contractTypeText(contractType: ContractType): MessageDescriptor {
  return contractTypeMessages[contractType];
}

export function toolCategoryText(category: ToolCategory): MessageDescriptor {
  if (category === "upcoming") {
    return msg`Скоро`;
  }
  return contractTypeText(category);
}

const skillCategoryMessages: Record<SkillCategory, MessageDescriptor> = {
  log_analysis: msg`Анализ логов`,
  network_map: msg`Карта сети`,
  phishing: msg`Разбор почты`,
  report_builder: msg`Сборка отчёта`,
  economy: msg`Экономика`,
  upcoming: msg`Скоро`,
};

export function skillCategoryText(category: SkillCategory): MessageDescriptor {
  return skillCategoryMessages[category];
}
